'use strict';
var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw });
    } else {
      cooked.raw = raw;
    }
    return cooked;
  };
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) {
              t[p] = s[p];
            }
          }
        }
        return t;
      };
    return __assign.apply(this, arguments);
  };
Object.defineProperty(exports, '__esModule', { value: true });
exports.DeskMutatedDocument =
  exports.UserPhoneSheetPrintSettingsDocument =
  exports.UserPhoneSheetFilterDocument =
  exports.GetPeopleDocument =
  exports.DeskDocument =
  exports.DeskStatusesDocument =
  exports.CallRecordsDocument =
  exports.CallRecordsStatusCheckDocument =
  exports.CallRecordsDuplicateCheckDocument =
  exports.UpdateUserPhoneSheetPrintSettingsDocument =
  exports.UpdateUserPhoneSheetFiltersDocument =
  exports.UpdateStatusDocument =
  exports.UpdateDeskDocument =
  exports.UpdateContactDocument =
  exports.UpdateCallRecordsStatusDocument =
  exports.UpdateCallRecordDocument =
  exports.LogoutDocument =
  exports.LoginDocument =
  exports.DeleteStatusDocument =
  exports.DeleteContactDocument =
  exports.DeleteCallRecordDocument =
  exports.CreateCallRecordDocument =
  exports.BulkDeleteCallRecordDocument =
  exports.AddContactDocument =
    void 0;
exports.useAddContactMutation = useAddContactMutation;
exports.useBulkDeleteCallRecordMutation = useBulkDeleteCallRecordMutation;
exports.useCreateCallRecordMutation = useCreateCallRecordMutation;
exports.useDeleteCallRecordMutation = useDeleteCallRecordMutation;
exports.useDeleteContactMutation = useDeleteContactMutation;
exports.useDeleteStatusMutation = useDeleteStatusMutation;
exports.useLoginMutation = useLoginMutation;
exports.useLogoutMutation = useLogoutMutation;
exports.useUpdateCallRecordMutation = useUpdateCallRecordMutation;
exports.useUpdateCallRecordsStatusMutation = useUpdateCallRecordsStatusMutation;
exports.useUpdateContactMutation = useUpdateContactMutation;
exports.useUpdateDeskMutation = useUpdateDeskMutation;
exports.useUpdateStatusMutation = useUpdateStatusMutation;
exports.useUpdateUserPhoneSheetFiltersMutation = useUpdateUserPhoneSheetFiltersMutation;
exports.useUpdateUserPhoneSheetPrintSettingsMutation = useUpdateUserPhoneSheetPrintSettingsMutation;
exports.useCallRecordsDuplicateCheckQuery = useCallRecordsDuplicateCheckQuery;
exports.useCallRecordsDuplicateCheckLazyQuery = useCallRecordsDuplicateCheckLazyQuery;
exports.useCallRecordsDuplicateCheckSuspenseQuery = useCallRecordsDuplicateCheckSuspenseQuery;
exports.useCallRecordsStatusCheckQuery = useCallRecordsStatusCheckQuery;
exports.useCallRecordsStatusCheckLazyQuery = useCallRecordsStatusCheckLazyQuery;
exports.useCallRecordsStatusCheckSuspenseQuery = useCallRecordsStatusCheckSuspenseQuery;
exports.useCallRecordsQuery = useCallRecordsQuery;
exports.useCallRecordsLazyQuery = useCallRecordsLazyQuery;
exports.useCallRecordsSuspenseQuery = useCallRecordsSuspenseQuery;
exports.useDeskStatusesQuery = useDeskStatusesQuery;
exports.useDeskStatusesLazyQuery = useDeskStatusesLazyQuery;
exports.useDeskStatusesSuspenseQuery = useDeskStatusesSuspenseQuery;
exports.useDeskQuery = useDeskQuery;
exports.useDeskLazyQuery = useDeskLazyQuery;
exports.useDeskSuspenseQuery = useDeskSuspenseQuery;
exports.useGetPeopleQuery = useGetPeopleQuery;
exports.useGetPeopleLazyQuery = useGetPeopleLazyQuery;
exports.useGetPeopleSuspenseQuery = useGetPeopleSuspenseQuery;
exports.useUserPhoneSheetFilterQuery = useUserPhoneSheetFilterQuery;
exports.useUserPhoneSheetFilterLazyQuery = useUserPhoneSheetFilterLazyQuery;
exports.useUserPhoneSheetFilterSuspenseQuery = useUserPhoneSheetFilterSuspenseQuery;
exports.useUserPhoneSheetPrintSettingsQuery = useUserPhoneSheetPrintSettingsQuery;
exports.useUserPhoneSheetPrintSettingsLazyQuery = useUserPhoneSheetPrintSettingsLazyQuery;
exports.useUserPhoneSheetPrintSettingsSuspenseQuery = useUserPhoneSheetPrintSettingsSuspenseQuery;
exports.useDeskMutatedSubscription = useDeskMutatedSubscription;
var client_1 = require('@apollo/client');
var Apollo = require('@apollo/client');
var defaultOptions = {};
exports.AddContactDocument = (0, client_1.gql)(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      [
        '\n    mutation AddContact($personId: String!, $input: AddContactInput!) {\n  addContact(personId: $personId, input: $input) {\n    message\n    success\n  }\n}\n    ',
      ],
      [
        '\n    mutation AddContact($personId: String!, $input: AddContactInput!) {\n  addContact(personId: $personId, input: $input) {\n    message\n    success\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useAddContactMutation__
 *
 * To run a mutation, you first call `useAddContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactMutation, { data, loading, error }] = useAddContactMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      input: // value for 'input'
 *   },
 * });
 */
function useAddContactMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.AddContactDocument, options);
}
exports.BulkDeleteCallRecordDocument = (0, client_1.gql)(
  templateObject_2 ||
    (templateObject_2 = __makeTemplateObject(
      [
        '\n    mutation BulkDeleteCallRecord($input: CallRecordBulkDeleteInput!) {\n  bulkDeleteCallRecord(input: $input) {\n    success\n    recordIds\n  }\n}\n    ',
      ],
      [
        '\n    mutation BulkDeleteCallRecord($input: CallRecordBulkDeleteInput!) {\n  bulkDeleteCallRecord(input: $input) {\n    success\n    recordIds\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useBulkDeleteCallRecordMutation__
 *
 * To run a mutation, you first call `useBulkDeleteCallRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteCallRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteCallRecordMutation, { data, loading, error }] = useBulkDeleteCallRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useBulkDeleteCallRecordMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.BulkDeleteCallRecordDocument, options);
}
exports.CreateCallRecordDocument = (0, client_1.gql)(
  templateObject_3 ||
    (templateObject_3 = __makeTemplateObject(
      [
        '\n    mutation CreateCallRecord($input: CallRecordInput!) {\n  createCallRecord(input: $input) {\n    contactInfo\n    contact {\n      _id\n      contact\n      contactType\n      private\n    }\n    createdAt\n    description\n    extension\n    notes {\n      _id\n      createdAt\n      createdBy\n      note\n      updatedAt\n      updatedBy\n    }\n    occurrence_date\n    recipientId\n    recipientName\n    status\n    updatedAt\n    companyName\n  }\n}\n    ',
      ],
      [
        '\n    mutation CreateCallRecord($input: CallRecordInput!) {\n  createCallRecord(input: $input) {\n    contactInfo\n    contact {\n      _id\n      contact\n      contactType\n      private\n    }\n    createdAt\n    description\n    extension\n    notes {\n      _id\n      createdAt\n      createdBy\n      note\n      updatedAt\n      updatedBy\n    }\n    occurrence_date\n    recipientId\n    recipientName\n    status\n    updatedAt\n    companyName\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useCreateCallRecordMutation__
 *
 * To run a mutation, you first call `useCreateCallRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCallRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCallRecordMutation, { data, loading, error }] = useCreateCallRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useCreateCallRecordMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.CreateCallRecordDocument, options);
}
exports.DeleteCallRecordDocument = (0, client_1.gql)(
  templateObject_4 ||
    (templateObject_4 = __makeTemplateObject(
      [
        '\n    mutation DeleteCallRecord($id: String!) {\n  deleteCallRecord(_id: $id) {\n    success\n    recordId\n  }\n}\n    ',
      ],
      [
        '\n    mutation DeleteCallRecord($id: String!) {\n  deleteCallRecord(_id: $id) {\n    success\n    recordId\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useDeleteCallRecordMutation__
 *
 * To run a mutation, you first call `useDeleteCallRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCallRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCallRecordMutation, { data, loading, error }] = useDeleteCallRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useDeleteCallRecordMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.DeleteCallRecordDocument, options);
}
exports.DeleteContactDocument = (0, client_1.gql)(
  templateObject_5 ||
    (templateObject_5 = __makeTemplateObject(
      [
        '\n    mutation DeleteContact($deskId: String!, $personId: String, $contactId: String!, $callTodoId: String) {\n  deleteContact(\n    deskId: $deskId\n    personId: $personId\n    contactId: $contactId\n    callTodoId: $callTodoId\n  ) {\n    message\n    success\n  }\n}\n    ',
      ],
      [
        '\n    mutation DeleteContact($deskId: String!, $personId: String, $contactId: String!, $callTodoId: String) {\n  deleteContact(\n    deskId: $deskId\n    personId: $personId\n    contactId: $contactId\n    callTodoId: $callTodoId\n  ) {\n    message\n    success\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      deskId: // value for 'deskId'
 *      personId: // value for 'personId'
 *      contactId: // value for 'contactId'
 *      callTodoId: // value for 'callTodoId'
 *   },
 * });
 */
function useDeleteContactMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.DeleteContactDocument, options);
}
exports.DeleteStatusDocument = (0, client_1.gql)(
  templateObject_6 ||
    (templateObject_6 = __makeTemplateObject(
      [
        '\n    mutation DeleteStatus($statuses: [DeskStatusInput!]!) {\n  deleteStatus(statuses: $statuses) {\n    message\n    success\n  }\n}\n    ',
      ],
      [
        '\n    mutation DeleteStatus($statuses: [DeskStatusInput!]!) {\n  deleteStatus(statuses: $statuses) {\n    message\n    success\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useDeleteStatusMutation__
 *
 * To run a mutation, you first call `useDeleteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStatusMutation, { data, loading, error }] = useDeleteStatusMutation({
 *   variables: {
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
function useDeleteStatusMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.DeleteStatusDocument, options);
}
exports.LoginDocument = (0, client_1.gql)(
  templateObject_7 ||
    (templateObject_7 = __makeTemplateObject(
      [
        '\n    mutation Login($email: String!, $currentToken: String!, $loginInterface: LoginInterface, $deviceId: String) {\n  login(\n    email: $email\n    currentToken: $currentToken\n    loginInterface: $loginInterface\n    deviceId: $deviceId\n  ) {\n    success\n  }\n}\n    ',
      ],
      [
        '\n    mutation Login($email: String!, $currentToken: String!, $loginInterface: LoginInterface, $deviceId: String) {\n  login(\n    email: $email\n    currentToken: $currentToken\n    loginInterface: $loginInterface\n    deviceId: $deviceId\n  ) {\n    success\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      currentToken: // value for 'currentToken'
 *      loginInterface: // value for 'loginInterface'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
function useLoginMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.LoginDocument, options);
}
exports.LogoutDocument = (0, client_1.gql)(
  templateObject_8 ||
    (templateObject_8 = __makeTemplateObject(
      [
        '\n    mutation Logout($email: String!, $currentToken: String!, $deviceId: String, $loginInterface: LoginInterface) {\n  logout(\n    email: $email\n    currentToken: $currentToken\n    deviceId: $deviceId\n    loginInterface: $loginInterface\n  ) {\n    success\n  }\n}\n    ',
      ],
      [
        '\n    mutation Logout($email: String!, $currentToken: String!, $deviceId: String, $loginInterface: LoginInterface) {\n  logout(\n    email: $email\n    currentToken: $currentToken\n    deviceId: $deviceId\n    loginInterface: $loginInterface\n  ) {\n    success\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      email: // value for 'email'
 *      currentToken: // value for 'currentToken'
 *      deviceId: // value for 'deviceId'
 *      loginInterface: // value for 'loginInterface'
 *   },
 * });
 */
function useLogoutMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.LogoutDocument, options);
}
exports.UpdateCallRecordDocument = (0, client_1.gql)(
  templateObject_9 ||
    (templateObject_9 = __makeTemplateObject(
      [
        '\n    mutation UpdateCallRecord($id: String!, $input: CallRecordUpdatePayload!, $azureId: String!, $email: String!) {\n  updateCallRecord(_id: $id, input: $input) {\n    callRecord {\n      _id\n      deskId\n      recipientType\n      recipientName\n      companyName\n      status\n      occurrence_date\n      contactInfo\n      extension\n      favorite\n      notes {\n        _id\n        note\n      }\n      contact {\n        contact\n        contactType\n        private\n        description\n      }\n      recipient(azure_id: $azureId, email: $email) {\n        _id\n        canEdit\n        type\n        name\n        profile_pic\n        outlook\n        title\n        directDial\n        verified\n        verifiedByName\n        verifiedOn\n        groupMembership {\n          group\n        }\n        companies {\n          _id\n          name\n          type\n        }\n        contacts {\n          _id\n          contact\n          contactType\n          description\n          primary\n          private\n          source\n        }\n      }\n    }\n    message\n    success\n  }\n}\n    ',
      ],
      [
        '\n    mutation UpdateCallRecord($id: String!, $input: CallRecordUpdatePayload!, $azureId: String!, $email: String!) {\n  updateCallRecord(_id: $id, input: $input) {\n    callRecord {\n      _id\n      deskId\n      recipientType\n      recipientName\n      companyName\n      status\n      occurrence_date\n      contactInfo\n      extension\n      favorite\n      notes {\n        _id\n        note\n      }\n      contact {\n        contact\n        contactType\n        private\n        description\n      }\n      recipient(azure_id: $azureId, email: $email) {\n        _id\n        canEdit\n        type\n        name\n        profile_pic\n        outlook\n        title\n        directDial\n        verified\n        verifiedByName\n        verifiedOn\n        groupMembership {\n          group\n        }\n        companies {\n          _id\n          name\n          type\n        }\n        contacts {\n          _id\n          contact\n          contactType\n          description\n          primary\n          private\n          source\n        }\n      }\n    }\n    message\n    success\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useUpdateCallRecordMutation__
 *
 * To run a mutation, you first call `useUpdateCallRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallRecordMutation, { data, loading, error }] = useUpdateCallRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      azureId: // value for 'azureId'
 *      email: // value for 'email'
 *   },
 * });
 */
function useUpdateCallRecordMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.UpdateCallRecordDocument, options);
}
exports.UpdateCallRecordsStatusDocument = (0, client_1.gql)(
  templateObject_10 ||
    (templateObject_10 = __makeTemplateObject(
      [
        '\n    mutation UpdateCallRecordsStatus($input: [CallRecordStatusUpdateInput!]!, $email: String!, $azureId: String!) {\n  updateCallRecordsStatus(input: $input) {\n    callRecord {\n      _id\n      deskId\n      recipientType\n      recipientName\n      companyName\n      status\n      occurrence_date\n      contactInfo\n      extension\n      favorite\n      notes {\n        _id\n        note\n      }\n      contact {\n        contact\n        contactType\n        private\n        description\n      }\n      recipient(azure_id: $azureId, email: $email) {\n        _id\n        canEdit\n        type\n        name\n        profile_pic\n        outlook\n        title\n        directDial\n        verified\n        verifiedByName\n        verifiedOn\n        groupMembership {\n          group\n        }\n        companies {\n          _id\n          name\n          type\n        }\n        contacts {\n          _id\n          contact\n          contactType\n          description\n          primary\n          private\n          source\n        }\n      }\n    }\n    message\n    success\n  }\n}\n    ',
      ],
      [
        '\n    mutation UpdateCallRecordsStatus($input: [CallRecordStatusUpdateInput!]!, $email: String!, $azureId: String!) {\n  updateCallRecordsStatus(input: $input) {\n    callRecord {\n      _id\n      deskId\n      recipientType\n      recipientName\n      companyName\n      status\n      occurrence_date\n      contactInfo\n      extension\n      favorite\n      notes {\n        _id\n        note\n      }\n      contact {\n        contact\n        contactType\n        private\n        description\n      }\n      recipient(azure_id: $azureId, email: $email) {\n        _id\n        canEdit\n        type\n        name\n        profile_pic\n        outlook\n        title\n        directDial\n        verified\n        verifiedByName\n        verifiedOn\n        groupMembership {\n          group\n        }\n        companies {\n          _id\n          name\n          type\n        }\n        contacts {\n          _id\n          contact\n          contactType\n          description\n          primary\n          private\n          source\n        }\n      }\n    }\n    message\n    success\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useUpdateCallRecordsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCallRecordsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallRecordsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallRecordsStatusMutation, { data, loading, error }] = useUpdateCallRecordsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *      email: // value for 'email'
 *      azureId: // value for 'azureId'
 *   },
 * });
 */
function useUpdateCallRecordsStatusMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.UpdateCallRecordsStatusDocument, options);
}
exports.UpdateContactDocument = (0, client_1.gql)(
  templateObject_11 ||
    (templateObject_11 = __makeTemplateObject(
      [
        '\n    mutation UpdateContact($deskId: String!, $personId: String, $contactId: String!, $input: UpdateContactInput!, $callTodoId: String) {\n  updateContact(\n    deskId: $deskId\n    personId: $personId\n    contactId: $contactId\n    input: $input\n    callTodoId: $callTodoId\n  ) {\n    message\n    success\n  }\n}\n    ',
      ],
      [
        '\n    mutation UpdateContact($deskId: String!, $personId: String, $contactId: String!, $input: UpdateContactInput!, $callTodoId: String) {\n  updateContact(\n    deskId: $deskId\n    personId: $personId\n    contactId: $contactId\n    input: $input\n    callTodoId: $callTodoId\n  ) {\n    message\n    success\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      deskId: // value for 'deskId'
 *      personId: // value for 'personId'
 *      contactId: // value for 'contactId'
 *      input: // value for 'input'
 *      callTodoId: // value for 'callTodoId'
 *   },
 * });
 */
function useUpdateContactMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.UpdateContactDocument, options);
}
exports.UpdateDeskDocument = (0, client_1.gql)(
  templateObject_12 ||
    (templateObject_12 = __makeTemplateObject(
      [
        '\n    mutation UpdateDesk($id: String!, $input: DeskUpdate!) {\n  updateDesk(_id: $id, input: $input) {\n    message\n    success\n    desk {\n      settings {\n        allowFutureCalls\n        denseMode\n        duplicateWarning\n        hideBulkEdits\n        hideFutureCalls\n      }\n      statuses {\n        _id\n        color\n        deskId\n        status\n        name\n        type\n        order\n        hasCallRecord\n        infiniteLoading\n      }\n      name\n      _id\n    }\n  }\n}\n    ',
      ],
      [
        '\n    mutation UpdateDesk($id: String!, $input: DeskUpdate!) {\n  updateDesk(_id: $id, input: $input) {\n    message\n    success\n    desk {\n      settings {\n        allowFutureCalls\n        denseMode\n        duplicateWarning\n        hideBulkEdits\n        hideFutureCalls\n      }\n      statuses {\n        _id\n        color\n        deskId\n        status\n        name\n        type\n        order\n        hasCallRecord\n        infiniteLoading\n      }\n      name\n      _id\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useUpdateDeskMutation__
 *
 * To run a mutation, you first call `useUpdateDeskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeskMutation, { data, loading, error }] = useUpdateDeskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateDeskMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.UpdateDeskDocument, options);
}
exports.UpdateStatusDocument = (0, client_1.gql)(
  templateObject_13 ||
    (templateObject_13 = __makeTemplateObject(
      [
        '\n    mutation UpdateStatus($input: [DeskStatusInput!]!) {\n  updateStatus(input: $input) {\n    message\n    success\n  }\n}\n    ',
      ],
      [
        '\n    mutation UpdateStatus($input: [DeskStatusInput!]!) {\n  updateStatus(input: $input) {\n    message\n    success\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useUpdateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusMutation, { data, loading, error }] = useUpdateStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateStatusMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.UpdateStatusDocument, options);
}
exports.UpdateUserPhoneSheetFiltersDocument = (0, client_1.gql)(
  templateObject_14 ||
    (templateObject_14 = __makeTemplateObject(
      [
        '\n    mutation UpdateUserPhoneSheetFilters($input: PhoneSheetFiltersInput!) {\n  updatePhoneSheetFilters(input: $input) {\n    _id\n    phoneSheetFilter {\n      deskId\n      filter\n      query\n      favorite\n    }\n  }\n}\n    ',
      ],
      [
        '\n    mutation UpdateUserPhoneSheetFilters($input: PhoneSheetFiltersInput!) {\n  updatePhoneSheetFilters(input: $input) {\n    _id\n    phoneSheetFilter {\n      deskId\n      filter\n      query\n      favorite\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useUpdateUserPhoneSheetFiltersMutation__
 *
 * To run a mutation, you first call `useUpdateUserPhoneSheetFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPhoneSheetFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPhoneSheetFiltersMutation, { data, loading, error }] = useUpdateUserPhoneSheetFiltersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateUserPhoneSheetFiltersMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.UpdateUserPhoneSheetFiltersDocument, options);
}
exports.UpdateUserPhoneSheetPrintSettingsDocument = (0, client_1.gql)(
  templateObject_15 ||
    (templateObject_15 = __makeTemplateObject(
      [
        '\n    mutation UpdateUserPhoneSheetPrintSettings($input: PhoneSheetPrintSettingsListInput!) {\n  updatePhoneSheetPrintSettings(input: $input) {\n    _id\n    phoneSheetPrintSettings {\n      deskId\n      excludedStatuses\n      hideFutureCalls\n    }\n  }\n}\n    ',
      ],
      [
        '\n    mutation UpdateUserPhoneSheetPrintSettings($input: PhoneSheetPrintSettingsListInput!) {\n  updatePhoneSheetPrintSettings(input: $input) {\n    _id\n    phoneSheetPrintSettings {\n      deskId\n      excludedStatuses\n      hideFutureCalls\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useUpdateUserPhoneSheetPrintSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserPhoneSheetPrintSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPhoneSheetPrintSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPhoneSheetPrintSettingsMutation, { data, loading, error }] = useUpdateUserPhoneSheetPrintSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateUserPhoneSheetPrintSettingsMutation(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useMutation(exports.UpdateUserPhoneSheetPrintSettingsDocument, options);
}
exports.CallRecordsDuplicateCheckDocument = (0, client_1.gql)(
  templateObject_16 ||
    (templateObject_16 = __makeTemplateObject(
      [
        '\n    query CallRecordsDuplicateCheck($deskId: String!, $recipientId: String!) {\n  callRecordsDuplicateCheck(deskId: $deskId, recipientId: $recipientId) {\n    callRecords {\n      _id\n      deskId\n    }\n  }\n}\n    ',
      ],
      [
        '\n    query CallRecordsDuplicateCheck($deskId: String!, $recipientId: String!) {\n  callRecordsDuplicateCheck(deskId: $deskId, recipientId: $recipientId) {\n    callRecords {\n      _id\n      deskId\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useCallRecordsDuplicateCheckQuery__
 *
 * To run a query within a React component, call `useCallRecordsDuplicateCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallRecordsDuplicateCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallRecordsDuplicateCheckQuery({
 *   variables: {
 *      deskId: // value for 'deskId'
 *      recipientId: // value for 'recipientId'
 *   },
 * });
 */
function useCallRecordsDuplicateCheckQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useQuery(exports.CallRecordsDuplicateCheckDocument, options);
}
function useCallRecordsDuplicateCheckLazyQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(exports.CallRecordsDuplicateCheckDocument, options);
}
function useCallRecordsDuplicateCheckSuspenseQuery(baseOptions) {
  var options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useSuspenseQuery(exports.CallRecordsDuplicateCheckDocument, options);
}
exports.CallRecordsStatusCheckDocument = (0, client_1.gql)(
  templateObject_17 ||
    (templateObject_17 = __makeTemplateObject(
      [
        '\n    query CallRecordsStatusCheck($deskId: String!, $statuses: [String!]!) {\n  callRecordsStatusCheck(deskId: $deskId, statuses: $statuses) {\n    hasCallRecord\n    status\n  }\n}\n    ',
      ],
      [
        '\n    query CallRecordsStatusCheck($deskId: String!, $statuses: [String!]!) {\n  callRecordsStatusCheck(deskId: $deskId, statuses: $statuses) {\n    hasCallRecord\n    status\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useCallRecordsStatusCheckQuery__
 *
 * To run a query within a React component, call `useCallRecordsStatusCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallRecordsStatusCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallRecordsStatusCheckQuery({
 *   variables: {
 *      deskId: // value for 'deskId'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
function useCallRecordsStatusCheckQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useQuery(exports.CallRecordsStatusCheckDocument, options);
}
function useCallRecordsStatusCheckLazyQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(exports.CallRecordsStatusCheckDocument, options);
}
function useCallRecordsStatusCheckSuspenseQuery(baseOptions) {
  var options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useSuspenseQuery(exports.CallRecordsStatusCheckDocument, options);
}
exports.CallRecordsDocument = (0, client_1.gql)(
  templateObject_18 ||
    (templateObject_18 = __makeTemplateObject(
      [
        '\n    query CallRecords($where: CallRecordWhere, $order: CallRecordOrder, $take: Int, $skip: Int, $azureId: String!, $email: String!) {\n  callRecords(order: $order, take: $take, skip: $skip, where: $where) {\n    callRecords {\n      _id\n      deskId\n      recipientType\n      recipientName\n      companyName\n      status\n      occurrence_date\n      contactInfo\n      extension\n      favorite\n      notes {\n        _id\n        note\n      }\n      contact {\n        contact\n        contactType\n        private\n        description\n      }\n      recipient(azure_id: $azureId, email: $email) {\n        _id\n        canEdit\n        type\n        name\n        profile_pic\n        outlook\n        title\n        directDial\n        verified\n        verifiedByName\n        verifiedOn\n        groupMembership {\n          group\n        }\n        companies {\n          _id\n          name\n          type\n        }\n        contacts {\n          _id\n          contact\n          contactType\n          description\n          primary\n          private\n          source\n        }\n      }\n    }\n    meta {\n      limit\n      more\n      skip\n      total\n    }\n  }\n}\n    ',
      ],
      [
        '\n    query CallRecords($where: CallRecordWhere, $order: CallRecordOrder, $take: Int, $skip: Int, $azureId: String!, $email: String!) {\n  callRecords(order: $order, take: $take, skip: $skip, where: $where) {\n    callRecords {\n      _id\n      deskId\n      recipientType\n      recipientName\n      companyName\n      status\n      occurrence_date\n      contactInfo\n      extension\n      favorite\n      notes {\n        _id\n        note\n      }\n      contact {\n        contact\n        contactType\n        private\n        description\n      }\n      recipient(azure_id: $azureId, email: $email) {\n        _id\n        canEdit\n        type\n        name\n        profile_pic\n        outlook\n        title\n        directDial\n        verified\n        verifiedByName\n        verifiedOn\n        groupMembership {\n          group\n        }\n        companies {\n          _id\n          name\n          type\n        }\n        contacts {\n          _id\n          contact\n          contactType\n          description\n          primary\n          private\n          source\n        }\n      }\n    }\n    meta {\n      limit\n      more\n      skip\n      total\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useCallRecordsQuery__
 *
 * To run a query within a React component, call `useCallRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallRecordsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      azureId: // value for 'azureId'
 *      email: // value for 'email'
 *   },
 * });
 */
function useCallRecordsQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useQuery(exports.CallRecordsDocument, options);
}
function useCallRecordsLazyQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(exports.CallRecordsDocument, options);
}
function useCallRecordsSuspenseQuery(baseOptions) {
  var options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useSuspenseQuery(exports.CallRecordsDocument, options);
}
exports.DeskStatusesDocument = (0, client_1.gql)(
  templateObject_19 ||
    (templateObject_19 = __makeTemplateObject(
      [
        '\n    query DeskStatuses($id: String) {\n  desks(where: {_id: $id}) {\n    statuses {\n      _id\n      color\n      deskId\n      status\n      name\n      type\n      order\n      hasCallRecord\n      infiniteLoading\n    }\n  }\n}\n    ',
      ],
      [
        '\n    query DeskStatuses($id: String) {\n  desks(where: {_id: $id}) {\n    statuses {\n      _id\n      color\n      deskId\n      status\n      name\n      type\n      order\n      hasCallRecord\n      infiniteLoading\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useDeskStatusesQuery__
 *
 * To run a query within a React component, call `useDeskStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeskStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeskStatusesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useDeskStatusesQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useQuery(exports.DeskStatusesDocument, options);
}
function useDeskStatusesLazyQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(exports.DeskStatusesDocument, options);
}
function useDeskStatusesSuspenseQuery(baseOptions) {
  var options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useSuspenseQuery(exports.DeskStatusesDocument, options);
}
exports.DeskDocument = (0, client_1.gql)(
  templateObject_20 ||
    (templateObject_20 = __makeTemplateObject(
      [
        '\n    query Desk($id: String) {\n  desks(where: {_id: $id}) {\n    _id\n    name\n    owner\n    statuses {\n      _id\n      color\n      deskId\n      status\n      name\n      type\n      order\n      hasCallRecord\n      infiniteLoading\n    }\n    settings {\n      allowFutureCalls\n      denseMode\n      duplicateWarning\n      hideBulkEdits\n      hideFutureCalls\n      collapseCallForm\n    }\n    addressBook {\n      name\n      contacts {\n        _id\n        contact\n        contactType\n        description\n      }\n    }\n  }\n}\n    ',
      ],
      [
        '\n    query Desk($id: String) {\n  desks(where: {_id: $id}) {\n    _id\n    name\n    owner\n    statuses {\n      _id\n      color\n      deskId\n      status\n      name\n      type\n      order\n      hasCallRecord\n      infiniteLoading\n    }\n    settings {\n      allowFutureCalls\n      denseMode\n      duplicateWarning\n      hideBulkEdits\n      hideFutureCalls\n      collapseCallForm\n    }\n    addressBook {\n      name\n      contacts {\n        _id\n        contact\n        contactType\n        description\n      }\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useDeskQuery__
 *
 * To run a query within a React component, call `useDeskQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useDeskQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useQuery(exports.DeskDocument, options);
}
function useDeskLazyQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(exports.DeskDocument, options);
}
function useDeskSuspenseQuery(baseOptions) {
  var options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useSuspenseQuery(exports.DeskDocument, options);
}
exports.GetPeopleDocument = (0, client_1.gql)(
  templateObject_21 ||
    (templateObject_21 = __makeTemplateObject(
      [
        '\n    query GetPeople($where: PersonWhere, $take: Int, $skip: Int) {\n  getPeople(where: $where, take: $take, skip: $skip) {\n    people {\n      _id\n      canEdit\n      directDial\n      email\n      hasPhoneOrEmail\n      name\n      phone\n      profile_pic\n      title\n      type\n      verified\n      verifiedOn\n      verifiedByName\n      companies {\n        _id\n        name\n        type\n      }\n      contacts {\n        _id\n        contact\n        contactType\n        description\n        primary\n        private\n        source\n      }\n    }\n    meta {\n      limit\n      more\n      skip\n      total\n    }\n  }\n}\n    ',
      ],
      [
        '\n    query GetPeople($where: PersonWhere, $take: Int, $skip: Int) {\n  getPeople(where: $where, take: $take, skip: $skip) {\n    people {\n      _id\n      canEdit\n      directDial\n      email\n      hasPhoneOrEmail\n      name\n      phone\n      profile_pic\n      title\n      type\n      verified\n      verifiedOn\n      verifiedByName\n      companies {\n        _id\n        name\n        type\n      }\n      contacts {\n        _id\n        contact\n        contactType\n        description\n        primary\n        private\n        source\n      }\n    }\n    meta {\n      limit\n      more\n      skip\n      total\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useGetPeopleQuery__
 *
 * To run a query within a React component, call `useGetPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeopleQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
function useGetPeopleQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useQuery(exports.GetPeopleDocument, options);
}
function useGetPeopleLazyQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(exports.GetPeopleDocument, options);
}
function useGetPeopleSuspenseQuery(baseOptions) {
  var options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useSuspenseQuery(exports.GetPeopleDocument, options);
}
exports.UserPhoneSheetFilterDocument = (0, client_1.gql)(
  templateObject_22 ||
    (templateObject_22 = __makeTemplateObject(
      [
        '\n    query UserPhoneSheetFilter($id: String!) {\n  users(where: {_id: $id}, skip: 0, take: 1) {\n    _id\n    phoneSheetFilter {\n      deskId\n      filter\n      query\n      favorite\n    }\n  }\n}\n    ',
      ],
      [
        '\n    query UserPhoneSheetFilter($id: String!) {\n  users(where: {_id: $id}, skip: 0, take: 1) {\n    _id\n    phoneSheetFilter {\n      deskId\n      filter\n      query\n      favorite\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useUserPhoneSheetFilterQuery__
 *
 * To run a query within a React component, call `useUserPhoneSheetFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPhoneSheetFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPhoneSheetFilterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useUserPhoneSheetFilterQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useQuery(exports.UserPhoneSheetFilterDocument, options);
}
function useUserPhoneSheetFilterLazyQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(exports.UserPhoneSheetFilterDocument, options);
}
function useUserPhoneSheetFilterSuspenseQuery(baseOptions) {
  var options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useSuspenseQuery(exports.UserPhoneSheetFilterDocument, options);
}
exports.UserPhoneSheetPrintSettingsDocument = (0, client_1.gql)(
  templateObject_23 ||
    (templateObject_23 = __makeTemplateObject(
      [
        '\n    query UserPhoneSheetPrintSettings($id: String!) {\n  users(where: {_id: $id}, skip: 0, take: 1) {\n    _id\n    phoneSheetPrintSettings {\n      deskId\n      excludedStatuses\n      hideFutureCalls\n    }\n  }\n}\n    ',
      ],
      [
        '\n    query UserPhoneSheetPrintSettings($id: String!) {\n  users(where: {_id: $id}, skip: 0, take: 1) {\n    _id\n    phoneSheetPrintSettings {\n      deskId\n      excludedStatuses\n      hideFutureCalls\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useUserPhoneSheetPrintSettingsQuery__
 *
 * To run a query within a React component, call `useUserPhoneSheetPrintSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPhoneSheetPrintSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPhoneSheetPrintSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useUserPhoneSheetPrintSettingsQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useQuery(exports.UserPhoneSheetPrintSettingsDocument, options);
}
function useUserPhoneSheetPrintSettingsLazyQuery(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(exports.UserPhoneSheetPrintSettingsDocument, options);
}
function useUserPhoneSheetPrintSettingsSuspenseQuery(baseOptions) {
  var options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useSuspenseQuery(exports.UserPhoneSheetPrintSettingsDocument, options);
}
exports.DeskMutatedDocument = (0, client_1.gql)(
  templateObject_24 ||
    (templateObject_24 = __makeTemplateObject(
      [
        '\n    subscription DeskMutated($deskId: String!) {\n  deskMutated(deskId: $deskId) {\n    _id\n    name\n    settings {\n      allowFutureCalls\n      denseMode\n      duplicateWarning\n      hideBulkEdits\n      hideFutureCalls\n    }\n    statuses {\n      _id\n      color\n      deskId\n      status\n      name\n      type\n      order\n      hasCallRecord\n    }\n  }\n}\n    ',
      ],
      [
        '\n    subscription DeskMutated($deskId: String!) {\n  deskMutated(deskId: $deskId) {\n    _id\n    name\n    settings {\n      allowFutureCalls\n      denseMode\n      duplicateWarning\n      hideBulkEdits\n      hideFutureCalls\n    }\n    statuses {\n      _id\n      color\n      deskId\n      status\n      name\n      type\n      order\n      hasCallRecord\n    }\n  }\n}\n    ',
      ]
    ))
);
/**
 * __useDeskMutatedSubscription__
 *
 * To run a query within a React component, call `useDeskMutatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeskMutatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeskMutatedSubscription({
 *   variables: {
 *      deskId: // value for 'deskId'
 *   },
 * });
 */
function useDeskMutatedSubscription(baseOptions) {
  var options = __assign(__assign({}, defaultOptions), baseOptions);
  return Apollo.useSubscription(exports.DeskMutatedDocument, options);
}
var templateObject_1,
  templateObject_2,
  templateObject_3,
  templateObject_4,
  templateObject_5,
  templateObject_6,
  templateObject_7,
  templateObject_8,
  templateObject_9,
  templateObject_10,
  templateObject_11,
  templateObject_12,
  templateObject_13,
  templateObject_14,
  templateObject_15,
  templateObject_16,
  templateObject_17,
  templateObject_18,
  templateObject_19,
  templateObject_20,
  templateObject_21,
  templateObject_22,
  templateObject_23,
  templateObject_24;
